import { getDefaultWildcardViewpoint } from 'traverseOneLevel/defaultWildcardViewpoint';
import {
  APIEntityType,
  APIViewpointAttributes,
  GroupType,
  TraversalPathMatchingType,
  ViewIds,
} from '@ardoq/api-types';
import { pluralizeWithCount } from '@ardoq/common-helpers';
import { getDefaultOverviewId } from './defaultOverview';
import { getDefaultOverviewName } from './defaultOverviewName';
import { type I18nLocale } from '@ardoq/i18n';

export const getViewpointDescription = (
  startType: string,
  selectedIds: string[],
  singleComponentName: string | null
) => {
  if (selectedIds.length > 1) {
    return `See everything directly connected to ${pluralizeWithCount(startType, selectedIds.length)}`;
  }
  return `See everything directly connected to ${singleComponentName}`;
};

type GetDefaultViewpointArgs = {
  startType: string;
  description: string;
  i18nLocale: I18nLocale;
};

export const getDefaultViewpoint = ({
  startType,
  description,
  i18nLocale,
}: GetDefaultViewpointArgs): APIViewpointAttributes => {
  return {
    _id: getDefaultOverviewId(startType),
    name: getDefaultOverviewName(startType, i18nLocale),
    description,
    startType,
    paths: getDefaultWildcardViewpoint(startType),
    viewName: ViewIds.MODERNIZED_BLOCK_DIAGRAM,
    pathMatching: TraversalPathMatchingType.LOOSE,
    groupBys: [
      {
        type: GroupType.WORKSPACE,
      },
      {
        type: GroupType.PARENT_ALL,
      },
    ],
    ...requiredDefaultViewpointProps,
  };
};

const requiredDefaultViewpointProps = {
  createdBy: '',
  _version: 0,
  created: '',
  createdByEmail: '',
  createdByName: '',
  lastModifiedBy: '',
  lastModifiedByEmail: '',
  lastModifiedByName: '',
  lastUpdated: '',
  ardoq: {
    'entity-type': APIEntityType.TRAVERSAL,
  },
};
